import { useTranslation } from 'react-i18next';
import {
  StyledGridContainer,
  StyledGridItem,
  StyledTypography,
  StyledDurationTypography,
  StyledStatusTypography,
} from './styled';

const TracklistHeader = () => {
  const { t } = useTranslation();

  return (
    <StyledGridContainer>
      <StyledGridItem xs={8}>
        <StyledTypography>
          {t('distribution:tracklist:songs:sections:track')}
        </StyledTypography>
      </StyledGridItem>
      <StyledGridItem xs={2}>
        <StyledDurationTypography>
          {t('distribution:tracklist:songs:sections:duration')}
        </StyledDurationTypography>
      </StyledGridItem>
      <StyledGridItem xs={2}>
        <StyledStatusTypography>
          {t('distribution:tracklist:songs:sections:status')}
        </StyledStatusTypography>
      </StyledGridItem>
    </StyledGridContainer>
  );
};

export default TracklistHeader;
